import { useState } from 'react';
import { resolveMediaUrl } from '@/lib/assetUrl';

export interface AttachedItem {
  id64: number;
  name: string;
  icon: string;
}

interface MessageInputProps {
  sendTitle: string;
  placeholder: string;
  attachTitle: string;
  attachedItem: AttachedItem | null;
  onAttachClick: () => void;
  onRemoveAttached: () => void;
  onSend: (text: string) => Promise<boolean>;
  onTyping: () => void;
  disabled?: boolean;
}

export function MessageInput({
  sendTitle,
  placeholder,
  attachTitle,
  attachedItem,
  onAttachClick,
  onRemoveAttached,
  onSend,
  onTyping,
  disabled,
}: MessageInputProps) {
  const [text, setText] = useState('');

  const handleSend = async () => {
    const trimmed = text.trim();
    if (!trimmed || disabled) return;
    if (await onSend(trimmed)) setText('');
  };

  return (
    <div className="chat-input-area">
      {attachedItem ? (
        <div className="attached-item-preview is-visible" id="attached-item-preview" style={{ display: 'flex' }}>
          <img src={resolveMediaUrl(attachedItem.icon)} alt="" className="attached-item-icon" />
          <span className="attached-item-name">{attachedItem.name}</span>
          <button type="button" className="remove-attached-item" id="remove-attached-btn" onClick={onRemoveAttached}>
            ×
          </button>
        </div>
      ) : null}

      <div className="chat-input-wrapper">
        <button
          type="button"
          id="attach-item-btn"
          className="btn-attach"
          title={attachTitle}
          onClick={onAttachClick}
          disabled={disabled}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e6c98a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
          </svg>
        </button>
        <input
          type="text"
          id="message-input"
          className="message-input"
          aria-label={placeholder}
          placeholder={placeholder}
          maxLength={1000}
          value={text}
          disabled={disabled}
          onChange={(e) => {
            setText(e.target.value);
            onTyping();
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              void handleSend();
            }
          }}
        />
        <button type="button" id="send-btn" className="btn-send" title={sendTitle} aria-label={sendTitle} onClick={() => void handleSend()} disabled={disabled || !text.trim()}>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="22" y1="2" x2="11" y2="13" />
            <polygon points="22 2 15 22 11 13 2 9 22 2" />
          </svg>
        </button>
      </div>
    </div>
  );
}
